import { GearSix } from "@phosphor-icons/react";
import { useState } from "react";

import NotEnoughSeats from "features/subscriptions/components/NotEnoughSeatsDialog";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import useAvailableLicensesCount from "common/hooks/useAvailableLicensesCount";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { WorkspaceAccount } from "common/types";

import DesktopDropdown from "./DesktopDropdown";
import MobileDrawer from "./MobileDrawer";

import type { MANAGE_ACCOUNTS_ACTIONS } from "../../constants";

export default function ManageAccounts({
  selectedAccounts,
}: {
  selectedAccounts: WorkspaceAccount[];
}) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<keyof typeof MANAGE_ACCOUNTS_ACTIONS>();
  const [isNotEnoughSeatsOpen, setIsNotEnoughSeatsOpen] = useState(false);
  const { availableLicensesCount } = useAvailableLicensesCount();

  const noLicenseAccounts = selectedAccounts.filter(
    ({ license, type }) => type === "user" && !license,
  );

  function onActionChange(action: keyof typeof MANAGE_ACCOUNTS_ACTIONS) {
    if (
      action === "seats" &&
      availableLicensesCount < noLicenseAccounts.length
    ) {
      setIsNotEnoughSeatsOpen(true);
    } else {
      setAction(action);
      setIsOpen(true);
    }
  }

  const triggerComponent = (
    <Button variant="secondary-purple" leftIcon={<GearSix />} size="sm">
      Manage accounts
    </Button>
  );

  const Component = isDesktop ? DesktopDropdown : MobileDrawer;

  return (
    <RestrictedComponent visibleForPermissions={["accounts_full"]}>
      <Component
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        action={action}
        setAction={onActionChange}
        selectedAccounts={selectedAccounts}
      >
        {triggerComponent}
      </Component>

      <NotEnoughSeats
        isOpen={isNotEnoughSeatsOpen}
        setIsOpen={setIsNotEnoughSeatsOpen}
        noSeatAccountIds={noLicenseAccounts.map(({ id }) => id)}
      />
    </RestrictedComponent>
  );
}
